<template>
    <div id="saveas">
        <at-modal v-model="show" title="Download" 
            @on-confirm="handleConfirm" @on-cancel="handleCancel" 
            :show-close="true" :mask-closable="false" :show-footer="false">
            
            <div class="vspace-2"></div> 

            <div class="left">
                <div class="section inline">Export as</div>
                <at-radio-group class="pitem left right inline" v-model="saveType" fill="#f18138">
                    <at-radio-button label="a">PNG</at-radio-button>
                    <at-radio-button label="b">JPEG</at-radio-button>
                    <at-radio-button v-if="animationEnabled==true" label="c">GIF</at-radio-button>
                </at-radio-group>
            </div>

            <div class="vspace"></div>

            <div v-if="info!=''">
                <div class="vspace"></div>
                {{info}}
                <div class="vspace"></div>
                <at-progress :percent="progress" :status="status"></at-progress>
                <div class="vspace"></div>
            </div>

            <div class="vspace"></div>
                <input type="button" class="brandColor borderColor downloadBtn" :value="downloadBtnName" @click="startImageDownload">
                <a id="downloadImage" href="#" target='_blank' download="downloadFileName"/>
            <div class="vspace"></div>
            
            <!--<div v-if="progress==100">
                <div class="vspace"/>
                <at-button type="primary" class="brandColor borderColor" @click="saveAsGif">
                    <a id="download" href="#" target='_blank' download="my_bezie_creation.gif"/>
                    Download GIF
                </at-button>
            </div>-->
            <div class="vspace"/>
        </at-modal>        
    </div>
</template>

<script>
import { BezieApp } from '../../lib/bezieLib/BezieApp';
import { UIEvents } from '../../lib/bezieLib/UI/UIEvents';
import GifJS from '../../lib/external/gif/gif';
import { UIUpdate } from '../../lib/bezieLib/UI/UIUpdate';

export default {
    name: 'SaveAs',
    props: ['show_saveas','bezieAppObj'],
    data: function(){
        return {
            show : false,
            progress: 0,
            status: '',
            info: '',
            blobUrl: "#",
            saveType : 'a',
            animationEnabled : false,
            downloadFileName : "my_bezie_creation.png",
            downloadBtnName : "Download"
        }
    },
    watch:{
        show_saveas: function(val){
            this.show = this.show_saveas;
            if(this.show){
                this.init();
            }
        },
        saveType: function(val){
            console.log("save type changed to "+val);
            this.progress = 0;
            this.status = '';
            this.info = '';
            this.blobUrl = "#";
        }
    },
    methods: {
        handleConfirm () {
            
        },
        handleCancel () {
            this.$emit('close', true);
            this.onClose();
        },
        getSaveTypeString(){
            if(this.saveType == 'a'){
                return 'png';
            }else if(this.saveType == 'b'){
                return 'jpeg';
            }else if(this.saveType == 'c'){
                return 'gif';
            }
        },
        init(){
            console.log("save as dialog initing");
            if(this.bezieAppObj){
                console.log("onFeatureFlagUpdate: "+this.bezieAppObj.featureFlags.enableAnimations);
                this.animationEnabled = this.bezieAppObj.featureFlags.enableAnimations;
                UIUpdate.addRenderListener(this);
                UIUpdate.addFeatureFlagChangeListener(this);
            }
        },
        startImageDownload(){
            var type = this.getSaveTypeString();
            if(type == 'png' || type == 'jpeg'){
                console.log("staring image download for type "+type);
                UIEvents.saveAs(type);
            }else if(type == 'gif'){
                this.generateGif();
            }
        },
        generateGif(){
            console.log("generating gif");
            var dim = this.bezieAppObj.getDimension();
            var worker = process.env.BASE_URL+"gif.worker.js";
                
            var gif = new GIF({
                workers: 2,
                quality: 10,
                workerScript: worker,
                debug: false,
                width: dim[0],
                height: dim[1]
            });
            
            if(gif){
                UIEvents.saveAsGif(gif);
            }else{
                console.log("GIF exporter is undefined")
                this.notifyError('Not able to export as GIF at this time. Try other export ways...');
            }
        },
        onExportReady(){
            this.downloadFileName = "my_bezie_creation."+this.getSaveTypeString();
            document.getElementById("downloadImage").setAttribute("download", this.downloadFileName);
            document.getElementById("downloadImage").setAttribute("href", this.blobUrl);
            //console.log("href:"+document.getElementById("downloadImage").getAttribute("href"));
            document.getElementById("downloadImage").click();
        },
        notifyError(errorMsg){
            this.$Notify({
                    title: 'Export error',
                    message: errorMsg,
                    type: 'error'
                })
        },
        onJPEGReady(){
            console.log("jpeg ready");
            if(this.blobUrl){
                this.onExportReady();
            }else{
                this.notifyError("Error in downloading generated JPEG!")
            }
        },
        onPNGReady(){
            console.log("png ready");
            if(this.blobUrl){
                this.onExportReady();
            }else{
                this.notifyError("Error in downloading generated PNG!")
            }
        },
        onGIFReady(){
            console.log("on GIF ready");
            if(this.blobUrl){
                this.onExportReady();
            }else{
                this.notifyError("Error in downloading generated GIF!")
            }
        },
        onStart(){
            console.log("on start");
            this.progress = 0;
            this.status = '';
            this.info = 'Generating '+this.getSaveTypeString();
            this.blobUrl = "#";
        },
        onProgress(val){
            if(Number(val)!=NaN){
                this.progress = Math.floor(val*100);
            }
        },
        onFinish(blob){
            console.log("on finish");
            
            this.progress = 100;
            this.info = 'Successfully generated '+this.getSaveTypeString();
            
            if(typeof blob == "string"){
                this.blobUrl = blob;
            }else{
                this.blobUrl = window.URL.createObjectURL(blob);
            }
            
            console.log("blobUrl:"+this.blobUrl);
            console.log("Url len:"+ this.blobUrl.length +" len:"+blob.length);
            
            if(this.blobUrl.startsWith("data:image/png")){
                this.onPNGReady();
            }else if(this.blobUrl.startsWith("data:image/jpeg")){
                this.onJPEGReady();
            }else {
                this.onGIFReady();
            }
        },
        onAbort(){
            console.log("on abort");
            this.status = 'error';
            this.notifyError("Error in generating the required format!");
        },
        onFeatureFlagUpdate(){
            console.log("onFeatureFlagUpdate");
            if(this.bezieAppObj){
                console.log("onFeatureFlagUpdate: "+this.bezieAppObj.featureFlags.enableAnimations);
                this.animationEnabled = this.bezieAppObj.featureFlags.enableAnimations;
            }
        },
        onClose(){
            UIUpdate.removeRenderListener(this);
            UIUpdate.removeFeatureFlagChangeListener(this);
        }
    },
    mounted: function(){
        this.init();
    },
    beforeDestroy: function(){
        this.onClose();
    }
}
</script>

<style scoped>

.downloadBtn{
    padding: 8px 16px;
    border-radius: 6px;
    color: white;
    border-style: none;
    outline-style: none;
}

.section{
  font-size: 16px;
}

.inline{
  display: inline-block;
}

.left-align{
    text-align: left;
}

.pitem{
  vertical-align: middle;
}

.vspace{
  height: 8px;
  width: 100%;
}

.vspace-2{
  height: 4px;
  width: 100%;
}

.left{
  margin-left: 10px;
}

.right{
  margin-right: 10px;
}

.is-small-width{
  width: 60px;
}

.is-long-width{
  width: 120px;
}

.is-long-width-4{
  width: 140px;
}

.is-long-width-8{
  width: 180px;
}

</style>